import { Box, SxProps, Theme, Tooltip } from '@mui/material';
import { getCountryCode } from '@utils';

const LatAmCountries = [
  'Mexico',
  'Argentina',
  'Colombia',
  'Brazil',
  'Guatemala',
];
interface IProps {
  country?: string;
  sx?: SxProps<Theme>;
  width?: number;
}
export const CountryFlag = ({ country, sx, width = 16 }: IProps) => {
  if (!country) return null;

  const includesUSA = country.includes('USA');

  const countries =
    country == 'LatAm' ? LatAmCountries : includesUSA ? ['USA'] : [country];

  return (
    <>
      {countries.map((country) =>
        getCountryCode(country) ? (
          <Tooltip title={country} placement="top" key={country}>
            <Box
              marginRight={'4px'}
              display={'inline-block'}
              key={country}
              sx={sx}
            >
              {country && (
                <img
                  loading="lazy"
                  width={width}
                  src={`https://flagcdn.com/w20/${getCountryCode(country)}.png`}
                  srcSet={`https://flagcdn.com/w40/${getCountryCode(
                    country,
                  )}.png 2x`}
                  alt={`${country} flag`}
                  style={{
                    borderRadius: '2px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,0.1)',
                  }}
                />
              )}
            </Box>
          </Tooltip>
        ) : (
          country
        ),
      )}
    </>
  );
};
